/**
 * Icon wrapper
 * Normalizes icon sizing and color while allowing optional gradient hover states.
 */

import styled, { css } from 'styled-components';
import { colors } from '@config/seafoam_colors';
import { transitions } from '@config/constants';

interface IconWrapperProps {
  $size?: number;
  $color?: string;
  $hoverGradient?: boolean;
}

export const IconWrapper = styled.span<IconWrapperProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size = 24 }) => `${$size}px`};
  height: ${({ $size = 24 }) => `${$size}px`};
  color: ${({ $color }) => $color ?? colors.text};
  transition: color ${transitions.fast} ${transitions.easing.easeOut};

  svg {
    width: 100%;
    height: 100%;
  }

  ${({ $hoverGradient }) =>
    $hoverGradient &&
    css`
      &:hover,
      &:focus-visible {
        color: ${colors.brand.primaryLight};
      }
    `}
`;

